import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { SharedModule } from '../shared.module';
import { ListComponent } from './pages/list/list.component';
import { MAT_MOMENT_DATE_ADAPTER_OPTIONS, MatMomentDateModule } from '@angular/material-moment-adapter';

const routes: Routes = [
  {
    path: '',
    component: ListComponent,
    data: { animation: 'isLeft' },
  },
];

@NgModule({
  declarations: [ListComponent],
  imports: [RouterModule.forChild(routes), SharedModule, MatMomentDateModule],
  providers: [{ provide: MAT_MOMENT_DATE_ADAPTER_OPTIONS, useValue: { useUtc: true } }],
})
export class MovementsModule {}
